import { useSelector } from "react-redux";
import { selectCurrent } from "../../../../../redux/settings/selectors";
import { FormattedMessage } from 'react-intl';
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../hooks/hooks";
import Table from "../../../../../common/components/table";
import { zones } from "../../../../../redux/zones/action";
import { selectZonesListItems } from "../../../../../redux/zones/selector";



const TransporterZones = () => {
	const dispatch = useAppDispatch()
  const [pageData, setPageData] = useState(1)
	const result = useSelector(selectCurrent)
	const { header, footer, currency } = result
    const orderItems = useSelector(selectZonesListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'LogisticsZoneName', headerName: 'Logistics Zone Name', sortable: true, filter: true, isEdit: true },
          { field: 'ContactPerson', headerName: 'ContactPerson' },
          { field: 'ContactNumber', headerName: 'ContactNumber'},
          { field: 'CreatedOnUtc', headerName: 'Created On' },
          { field: 'ModifiedOnUtc', headerName: 'ModifiedOnUtc'}
      
        ]);
      }
      const fetchZones=()=>{
      	dispatch(zones.list({url:`https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/zones/list`,entity:'zones',jsonData:{
          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",
        }}))
      }
	useEffect(() => {
        createColumnDefs()
        fetchZones()
	}, [pageData])

	return (
   
		<Table columnData={columnDefs} rowData={orderItems?.result?.items} setPageData={setPageData}
    paginationData={orderItems?.result?.pagination} headingName="Zones"/>
       
	);
};

export default TransporterZones;


